'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var Pill_web = require('../../atoms/Pill/Pill.web.cjs');
var Skeleton_web = require('../../atoms/Skeleton/Skeleton.web.cjs');
var Typography_web = require('../../atoms/Typography/Typography.web.cjs');
var DiscountedPrice_web = require('./variants/DiscountedPrice.web.cjs');
var WholesalePrice_web = require('./variants/WholesalePrice.web.cjs');
var Price_web_styles = require('./Price.web.styles.cjs');

/**
 * Displays the cost of a product or service.
 *
 * {@link https://aviary.fullscript.io/latest/components/price/web-J9CYsVnC | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/platform/Price/Price.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Price = ({ msrp, sellPrice, variant = "bold", isBlurred = false, isLoading = false, customCss, isNegative = false, isStart = false, hasHandlingFee = false, isFree = false, isCAD = false, discountPill, ...rest })=>{
    const negativeSign = isNegative ? "-" : "";
    const formattedMsrp = isFree ? "Free" : `${negativeSign}$${Math.abs(msrp).toFixed(2)}`;
    const formattedSellPrice = `$${Number(sellPrice).toFixed(2)}`;
    const handlingFeeText = hasHandlingFee ? "+ handling fee may apply" : "";
    if (isLoading) return /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
        variant: "typography"
    });
    const isDiscounted = sellPrice !== undefined && sellPrice !== msrp && !isFree;
    const showStart = isStart && variant === "regular" && !(isDiscounted || isFree);
    const renderVariant = ()=>{
        if (variant === "wholesale" && sellPrice !== undefined) {
            return /*#__PURE__*/ jsxRuntime.jsx(WholesalePrice_web.WholesalePrice, {
                formattedSellPrice: formattedSellPrice,
                msrp: msrp,
                isCAD: isCAD
            });
        }
        if (isDiscounted) return /*#__PURE__*/ jsxRuntime.jsxs("div", {
            css: [
                Price_web_styles.discountPriceContainer
            ],
            children: [
                /*#__PURE__*/ jsxRuntime.jsx(DiscountedPrice_web.DiscountedPrice, {
                    formattedSellPrice: formattedSellPrice,
                    formattedMsrp: formattedMsrp,
                    isCAD: isCAD
                }),
                discountPill && /*#__PURE__*/ jsxRuntime.jsx(Pill_web.Pill, {
                    intention: "warning",
                    tooltipContent: discountPill.tooltipContent,
                    size: "small",
                    icon: index.faTags,
                    children: `Extra ${discountPill.discountPercent}% off`
                })
            ]
        });
        return /*#__PURE__*/ jsxRuntime.jsxs(Typography_web.Typography, {
            as: "span",
            isMarginless: true,
            variant: variant === "small" ? "footnote" : "body",
            fontWeight: variant === "bold" ? "bold" : "regular",
            children: [
                formattedMsrp,
                " ",
                isCAD ? "CAD" : ""
            ]
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: [
            Price_web_styles.container,
            isBlurred && Price_web_styles.blur,
            customCss
        ],
        "data-testid": "aviary-price",
        ...rest,
        children: [
            showStart && /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                as: "span",
                colorIntensity: "subtle",
                isMarginless: true,
                children: "Starts at"
            }),
            renderVariant(),
            /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                as: "span",
                variant: "caption",
                colorIntensity: "subtle",
                isMarginless: true,
                children: handlingFeeText
            })
        ]
    });
};

exports.Price = Price;
//# sourceMappingURL=Price.web.cjs.map
